// extracted by mini-css-extract-plugin
export default {"responsiveBar":"ProportionsBar_responsiveBar__7dH+e"};